import clsx from 'clsx'

import useViewModel from './ViewModel'

const ResetPasswordView: React.FC = () => {
  const { formik } = useViewModel()

  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title fw-bold'>เปลี่ยนรหัสผ่าน</div>
      </div>
      <div className='card-body'>
        <form
          className='form fv-plugins-bootstrap5 fv-plugins-framework w-100 w-md-500px'
          noValidate
          onSubmit={formik.handleSubmit}>
          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder text-gray-900 fs-6 required'>
              รหัสผ่านปัจจุบัน
            </label>
            <input
              type='password'
              placeholder=''
              autoComplete='off'
              {...formik.getFieldProps('oldPassword')}
              className={clsx(
                'form-control bg-transparent',
                { 'is-invalid': formik.touched.oldPassword && formik.errors.oldPassword },
                { 'is-valid': formik.touched.oldPassword && !formik.errors.oldPassword }
              )}
            />
            {formik.touched.oldPassword && formik.errors.oldPassword && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.oldPassword}</span>
                </div>
              </div>
            )}
          </div>

          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder text-gray-900 fs-6 required'>รหัสผ่านใหม่</label>
            <input
              type='password'
              placeholder=''
              autoComplete='off'
              {...formik.getFieldProps('newPassword')}
              className={clsx(
                'form-control bg-transparent',
                { 'is-invalid': formik.touched.newPassword && formik.errors.newPassword },
                { 'is-valid': formik.touched.newPassword && !formik.errors.newPassword }
              )}
            />
            {formik.touched.newPassword && formik.errors.newPassword && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.newPassword}</span>
                </div>
              </div>
            )}
          </div>

          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder text-gray-900 fs-6 required'>
              ยืนยันรหัสผ่านใหม่
            </label>
            <input
              type='password'
              placeholder=''
              autoComplete='off'
              {...formik.getFieldProps('confirmPassword')}
              className={clsx(
                'form-control bg-transparent',
                { 'is-invalid': formik.touched.confirmPassword && formik.errors.confirmPassword },
                { 'is-valid': formik.touched.confirmPassword && !formik.errors.confirmPassword }
              )}
            />
            {formik.touched.confirmPassword && formik.errors.confirmPassword && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.confirmPassword}</span>
                </div>
              </div>
            )}
          </div>

          <div className='d-flex'>
            <button
              type='submit'
              className='btn btn-primary'
              disabled={formik.isSubmitting || !formik.isValid}>
              <span className='indicator-label'>ยืนยัน</span>
              {formik.isSubmitting && (
                <span className='indicator-progress' style={{ display: 'inline' }}>
                  {' '}
                  กรุณารอ
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ResetPasswordView
